import React from 'react';
import { getDetailLink } from '../../../lib/helpers/index';
import styles from './ContractsRow.module.scss';
import { LinkObjectType } from '../../../lib/helpers/types';
import { gql, DocumentNode } from '@apollo/client';
import { SignContractsModalRowContractFragment } from '#types';
import { ListItem, ListItemText } from '@mui/material';
import { Button } from '../../Button';

const signContractsModalRowContractFragment = gql`
	fragment signContractsModalRowContract on SignatureContract {
		id
		title
		guestToken
	}
`;

export type ContractRowProps = {
	contract: SignContractsModalRowContractFragment;
	onNavigate?: () => any;
};

type ContractRowPropsWithFragment = React.FC<ContractRowProps> & {
	fragments: {
		signContractsModalRowContractFragment: DocumentNode;
	};
};

interface LinkParam {
	token?: string;
}

const ContractsRow: ContractRowPropsWithFragment = ( {
	contract,
	onNavigate,
} ) => {
	if ( !contract ) {
		return null;
	}

	const linkObject = contract;
	const linkParams: LinkParam = {
		...( contract.guestToken ? { token: contract.guestToken } : {} ),
	};
	const link = getDetailLink( {
		object: linkObject,
		params: linkParams,
		type: LinkObjectType.Contract,
	} );

	return (
		<ListItem disableGutters>
			<ListItemText className={ styles.contractDetails }>
				{ contract.title }
			</ListItemText>
			{ link ? (
				<Button
					{ ...link }
					onClick={ onNavigate }
					className={ styles.button }
					data-cy={ `sign-contract-btn-${ contract.id }` }
				>
					Sign
				</Button>
			) : null }
		</ListItem>
	);
};

ContractsRow.fragments = {
	signContractsModalRowContractFragment,
};

export default ContractsRow;
